/**
 * - seeAlso
 * - service
 * - logo
 * - homepage
 * - rendering
 * - partOf
 * - start
 * - supplementary
 */

import { getSeeAlso, getService, getRendering } from '../../2.x/iiif/linking';

var getHomepage = function getHomepage(resource) {
  return resource.homepage || null;
};

var getPartOf = function getPartOf(resource) {
  return resource.partOf || null;
};

var getStart = function getStart(resource) {
  return resource.start || null;
};

var getSupplementary = function getSupplementary(resource) {
  return resource.supplementary || [];
};

var getLogo = function getLogo(resource) {
  return resource.logo || [];
};

var getBody = function getBody(resource) {
  return resource.body || [];
};

var getTarget = function getTarget(resource) {
  return resource.target || [];
};

export { getSeeAlso, getService, getLogo, getHomepage, getRendering, getPartOf, getStart, getSupplementary, getBody, getTarget };